// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const DeviceContactListsAPI = {
    ReplaceContactLists(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/contacts/devices/${req["deviceId"]}/contact-lists`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    GetContactLists(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/contacts/devices/${req["deviceId"]}/contact-lists?${fm.renderURLSearchParams(req, ["deviceId"])}`, { method: "GET" });
    },
    RemoveContactList(fn, req) {
        try {
            fm.validateUrlParam(req["deviceId"], "deviceId");
            fm.validateUrlParam(req["contactListId"], "contactListId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/contacts/devices/${req["deviceId"]}/contact-lists/${req["contactListId"]}?${fm.renderURLSearchParams(req, ["deviceId", "contactListId"])}`, { method: "DELETE" });
    },
};
